module.exports = __webpack_public_path__ + "img/EL.0878be96.png";